import { ReactElement } from 'react'
import { Box, Stack } from '@mui/material'
import StoreyBoundariesForm from '@editor/pages/StructuralPlanning/components/RoofDrawing/components/RoofForm/components/StoreyBoundariesForm'
import WallAlignmentForm from '@editor/pages/StructuralPlanning/components/RoofDrawing/components/RoofForm/components/WallAlignmentForm'

interface Props {
  /** Hide the "Wände an SW zuschneiden" button, not needed in the guided IFC workflow. */
  hideAdvancedControls?: boolean
}

const BuildingForm = ({ hideAdvancedControls = false }: Props): ReactElement => (
  <Box>
    <Stack direction="column" spacing={1}>
      {!hideAdvancedControls && <WallAlignmentForm />}
      <StoreyBoundariesForm />
    </Stack>
  </Box>
)

export default BuildingForm
